import React, { useState } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import scope from "../../live-code-components"
import tokens from "../_tokens"
import ClipboardCopy from "./clipboard-copy"
import LivePreviewWrapper from "./live-preview-wrapper"
import htmlReactParser from "html-react-parser"
import githubTheme from "prism-react-renderer/themes/github"
import reactElementToJsxString from "react-element-to-jsx-string"
import { LiveEditor, LiveError, LivePreview, LiveProvider } from "react-live"

const ClipboardCopyStyled = styled(ClipboardCopy)`
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.5em 1em;
  margin: 0.5em;
`

const StyledContainer = styled.div`
  margin-bottom: ${1.5 * tokens.size.base}px;
  display: flex;
  flex-direction: column;
  display: flex;
  border: 1px solid ${tokens.color.border};
  border-radius: 6px;
`

const StyledText = styled.span`
  font-family: ${tokens.font.mono};
  font-size: ${tokens.fontSize.text.s};
  margin: 0;
  padding: ${1.5 * tokens.size.base}px;
  color: ${tokens.color.white};
  background-color: ${tokens.color.error};
`

const languageTransformers = {
  html: html => htmlToJsx(html),
  jsx: jsx => wrapWithFragment(jsx),
}

function htmlToJsx(html) {
  try {
    const reactElement = htmlReactParser(removeNewlines(html))
    // The output of htmlReactParser could be a single React element
    // or an array of React elements. reactElementToJsxString does not accept arrays
    // so we have to wrap the output in React fragment.
    return reactElementToJsxString(<>{reactElement}</>)
  } catch (error) {
    return wrapWithFragment(html)
  }
}

function removeNewlines(string) {
  return string.replace(/(\r\n|\n|\r)/gm, "")
}

function wrapWithFragment(jsx) {
  return `<React.Fragment>${jsx}</React.Fragment>`
}

function LiveCode({ code, language, noinline, nocode }) {
  const [liveCode, setLiveCode] = useState(code)
  const handleChange = updatedLiveCode => setLiveCode(updatedLiveCode)

  return (
    <StyledContainer>
      <LiveProvider
        scope={scope}
        code={liveCode}
        transformCode={languageTransformers[language]}
        noInline={noinline}
      >
        <LivePreviewWrapper>
          <LivePreview />
        </LivePreviewWrapper>
        {!nocode && (
          <div style={{ position: "relative" }}>
            <LiveEditor
              onChange={handleChange}
              theme={githubTheme}
              ignoreTabKey={true}
              padding={1.5 * tokens.size.base + "px"}
              px
              style={{
                fontFamily: tokens.font.mono,
                fontSize: "85%",
                borderBottomLeftRadius: "6px",
                borderBottomRightRadius: "6px",
              }}
            />
            <ClipboardCopyStyled value={liveCode} />
          </div>
        )}
        <StyledText as={LiveError} />
      </LiveProvider>
    </StyledContainer>
  )
}

LiveCode.propTypes = {
  code: PropTypes.node,
  language: PropTypes.string,
  nocode: PropTypes.bool,
  noinline: PropTypes.bool,
}

export default LiveCode
